import { BREAST_SIZE_OPTIONS } from '../BREAST_SIZE_OPTIONS';
import { BreastSizeOptionIdType } from '../types';

export const getBreastSizeIdByTitle = (
  title: string | null | undefined,
): BreastSizeOptionIdType | null => {
  if (!title) {
    return null;
  }

  const option = BREAST_SIZE_OPTIONS.find(
    (option) => option.title.toLowerCase() === title.toLowerCase(),
  );

  return option?.id ?? null;
};
